import datadogRumManager from '@/third-party/datadogRumManager';
import config from './config';
import { datadogLogs } from '@datadog/browser-logs';
import { ENV } from './environment';
import store from './store';
import { isInternalStaff } from '@/utils/user';

export const INSCRIBE_EVENTS = {
  APP_LOADED: 'app-loaded',
  DOCUMENT_TABS_CLICKED: 'document-tabs-clicked',
  CUSTOMER_CTA_CLICKED: 'customer-cta-clicked',
  CUSTOMERS_SEARCH_CLICKED: 'customers-search-clicked',
  CUSTOMERS_FILTER_CLICKED: 'customers-filter-clicked',
  DOCUMENTS_SEARCH_CLICKED: 'documents-search-clicked',
  CSRF_TOKEN_LOADING_ERROR: 'csrf-token-error',
  UPSELL_BUTTON_CLICKED: 'upsell-button-clicked',
  CHAT_AGENT_HOOK_CLICKED: 'chat-agent-hook-clicked',
  TOO_MANY_REQUESTS_NOTIFIED: 'too-many-requests-notified',
  HTTP_400_RESPONSE: 'http-400-response',
};

export const InscribeEventsLogger = {
  DD_SERVICE_NAME: 'inscribe-frontend',
  LOGGING_ENABLED: false,

  init: () => {
    if (!InscribeEventsLogger.LOGGING_ENABLED) {
      return;
    }
    const CONFIG = config[ENV];
    const commonConfig = {
      service: InscribeEventsLogger.DD_SERVICE_NAME,
      env: ENV,
      version: document.getElementById('app-version')?.innerText,
    };

    datadogRumManager.cleaners.params = ['Signature', 'session'];
    datadogRumManager.init({
      ...commonConfig,
      applicationId: CONFIG.datadog_rum.applicationId,
      clientToken: CONFIG.datadog_rum.clientToken,
      trackUserInteractions: true,
      enableExperimentalFeatures: ['clickmap'],
      actionNameAttribute: 'class',
    });

    if (datadogLogs) {
      window.DD_LOGS.init({
        ...commonConfig,
        applicationId: CONFIG.datadog_rum.applicationId,
        clientToken: CONFIG.datadog_rum.clientToken,
      });

      window.DD_LOGS.onReady(function () {
        InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.APP_LOADED);
      });
    }
  },

  logEvent(name, data, preventLoggingForInternalUsers = false) {
    if (
      !InscribeEventsLogger.LOGGING_ENABLED ||
      (preventLoggingForInternalUsers &&
        isInternalStaff(store?.getters?.getCurrentUser))
    ) {
      return;
    }
    window.DD_LOGS?.logger.info(name, data);
  },

  logError(name, data) {
    if (!InscribeEventsLogger.LOGGING_ENABLED) {
      return;
    }
    window.DD_LOGS?.logger.error(name, {}, data);
  },

  clearItemName(name) {
    return name?.replace(/ /g, '_').toLowerCase();
  },
};

export const registerChatAgentHookClickEvent = (hookId) => {
  if (!hookId) {
    return;
  }
  InscribeEventsLogger.logEvent(
    INSCRIBE_EVENTS.CHAT_AGENT_HOOK_CLICKED,
    {
      hookId,
    },
    true,
  );
};
